import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";
import { gradientWithWhiteBackground } from "@/components/AIComponents/AiComponents.style";

const { ui } = constants.colors;
const { textMObj } = typographyStyles;

export const textAreaWrapperCss: CSSObject = {
  marginBottom: "0.75rem",
};

export const labelCss: CSSObject = {
  color: ui.neutral[700],

  ":after": {
    content: '"*"',
    color: ui.core[500],
    marginLeft: "0.25rem",
  },
};

export const textAreaCss: CSSObject = {
  ...textMObj,
  width: "100%",
  height: "fit-content",
  padding: "0.75rem 1rem",
  boxSizing: "border-box",
  border: "1px solid transparent",
  borderRadius: "8px",
  background: gradientWithWhiteBackground,
  backgroundClip: "padding-box, border-box",

  "&:hover, &:focus-within": {
    border: "1px solid transparent",
    background: gradientWithWhiteBackground,
    backgroundClip: "padding-box, border-box",
  },
};
